export default __webpack_public_path__ + "static/media/search.034ad363.svg";